import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {appConfig} from "../data/config";

export interface IAppState {
    page: string;
    loading: 'idle' | 'pending' | 'succeeded' | 'failed'
}

export const setPage = createAsyncThunk(
    'fetchReports',
    async (props: {
        page: string,
        useRouter?: boolean
    }, {dispatch}) => {

        dispatch(setAppPage({
            page: props.page
        }))

        let useRouter = true;

        if (props.useRouter !== undefined) {
            if (!props.useRouter) useRouter = false;
        }

        if (useRouter) {
            window.history.pushState("", "", `/page/${props.page}`);
        }
    }
)

const initial: IAppState = {
    page: appConfig.pageDefault,
    loading: 'idle',
};

const appSlice = createSlice({
    name: 'app-state',
    initialState: initial,
    reducers: {
        setPage(state, action: PayloadAction<{ page: string }>) {
            state.page = action.payload.page;
        },
    }
});

export const appReducer = appSlice.reducer;

export const setAppPage = appSlice.actions.setPage;

export const getAppPage = (state: IAppState) => state.page;
